import { useShortIdContext } from '@air/provider-short-id';

/**
 * Whether the publisher opted to remove Air's branding — the Air logo and the
 * "Sign up for Air" CTA — from the public share-link viewer. Backed by the
 * `presentationSettings.hideAirLogo` flag returned for `clip`, `board`, and
 * `collection` share links.
 *
 * Must be called within a `ShortIdProvider` (i.e. on a public share page).
 */
export const useHideAirLogo = (): { hideAirLogo: boolean } => {
  const { presentationSettings } = useShortIdContext();

  return { hideAirLogo: presentationSettings?.hideAirLogo === true };
};
